<template>
  <!-- TODO: Traiter surTitre,titre et sousTitre -->
  <div class="d-flex flex-column align-items-center" :class="jel_getClassObject(content)">
    <b-link v-bind="jel_getLienBinding(content.lien)">
      <b-img
        :src="jel_getFichierSrc(content.image)"
        :alt="content.altImage"
        class="imgPleineLargeur"
      />
    </b-link>
    <div class="cursor-pointer w-100 ml-4" @click="jel_forcerClickHyperlien(refRedirection)">
      <b-link :ref="refRedirection" v-bind="jel_getLienBinding(content.lien)" class="d-none">
        <!-- conserver pour accessibilité -->
        invisible</b-link
      >
      <!-- Erreur d'accessibilité. Un inline element ne peut contenir un block element -->
      <b-row ref="texteSousImage" class="w-100 mt-2 hauteur">
        <div class="col-sm-12 col-xxl-6 p-0 texte media-img-titre" v-html="content.titre"></div>
        <div
          class="col-sm-12 col-xxl-6 p-0 d-flex justify-content-sm-start justify-content-xxl-end texte media-img-sous-titre"
        >
          <div class="media-img-titre" v-html="content.sousTitre"></div>
          <div class="pl-1" v-html="content.deuxiemeSousTitre"></div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaImageImg90TitSouTit',
  props: { content: { type: Object, required: true } },
  data() {
    return {
      refRedirection: this._uid,
    };
  },
};
</script>
<style lang="scss" scoped>
.media-img-titre {
  color: $couleur-primaire;
  font-weight: bold;
}

.media-img-sous-titre {
  color: $couleur-primaire;
  @include rfs(11.25px, font-size);
}

.imgPleineLargeur {
  width: 100%;
}
.hauteur {
  height: 2.5rem;
}

a:hover {
  text-decoration: none;
}
</style>
